export default {"src":"/_next/static/media/access.f697bcd6.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};